module.exports = __webpack_public_path__ + "img/stickingPersonTimeSecond.48812abc.svg";